// extracted by mini-css-extract-plugin
export default {"container":"FirstLevel_container__CTiou","lessonName":"FirstLevel_lessonName__ydtiU","blocks":"FirstLevel_blocks__pyQYp","emptyList":"FirstLevel_emptyList__UJBBg"};